import { useEffect } from 'react';
import { useApp, type ScreenId } from '../state/store';

/**
 * Statusfält/Safari-chrome per skärm.
 *
 * iOS-verklighet (Safari, URL-fält i botten): `theme-color` är det ENDA som
 * färgar toppens statusfält — och den färgar topp OCH botten-verktygsraden
 * tillsammans (går inte att separera). Fotoskärmarna får därför en cream
 * `theme-color` som matchar bildens topp (botten blir cream på köpet — borta
 * i standalone/PWA där ingen URL-rad finns). Övriga skärmar → temats bas.
 *
 * `body.photo-bg` (app.css) lägger dessutom fotot på body-canvasen för
 * innehållsytan; den färgen krockar inte med detta.
 */
const PHOTO_SCREENS = new Set<ScreenId>([1, 2]);
const THEME_COLOR: Record<ScreenId, string> = {
  1: '#eee8d3',
  2: '#eee8d3',
  3: '#fcfaf6',
  4: '#fcfaf6',
};

export function useStatusBarColor(): void {
  const screen = useApp((s) => s.screen);

  useEffect(() => {
    document.body.classList.toggle('photo-bg', PHOTO_SCREENS.has(screen));

    let meta = document.querySelector('meta[name="theme-color"]');
    if (!meta) {
      meta = document.createElement('meta');
      meta.setAttribute('name', 'theme-color');
      document.head.appendChild(meta);
    }
    meta.setAttribute('content', THEME_COLOR[screen]);
  }, [screen]);
}
